import React from 'react';
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Button,
    Container,
    TextField,
    Avatar,
    Link,
    Box
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { useSnackbar } from 'notistack';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import validateEmail from 'utils/emailValidation';
import sendPasswordResetEmail from 'services/sendPasswordResetEmail';
import { usePasswordResetStyles } from '../PasswordResetStyles';
import { LoadingButton } from '@mui/lab';

const ForgotPasswordContainer = () => {
    const [email, setEmail] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const classes = usePasswordResetStyles();
    const navigate = useNavigate();

    const { enqueueSnackbar } = useSnackbar();

    const handleTriggerPasswordReset = async () => {
        if (!validateEmail(email)) {
            enqueueSnackbar('The email format is invalid', { variant: 'error' });
            return;
        }
        setLoading(true);

        try {
            await sendPasswordResetEmail(email);
        } finally {
            setLoading(false);
            enqueueSnackbar(
                `Please check your email for instructions on how to reset your password`,
                {
                    variant: 'success'
                }
            );
        }
    };

    return (
        <div className={classes.root}>
            <AppBar position="static" elevation={0}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        className={classes.menuButton}
                        color="inherit"
                        aria-label="menu"
                        onClick={() => {
                            navigate('/signin');
                        }}
                    >
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        Sign in
                    </Typography>
                    <Button color="inherit">EQL</Button>
                </Toolbar>
            </AppBar>
            <main>
                <Container component="main" maxWidth="sm">
                    <div className={classes.paper}>
                        <Avatar className={classes.avatar}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Reset Password
                        </Typography>
                        <form className={classes.form} noValidate>
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="email"
                                        label="Email Address"
                                        name="email"
                                        autoComplete="email"
                                        onChange={(evt) => setEmail(evt.target.value)}
                                        error={!email.match(/@/)}
                                    />
                                </Grid>
                            </Grid>
                            <Box mt={2}>
                                <LoadingButton
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={handleTriggerPasswordReset}
                                    disabled={!email.match(/@/) || loading}
                                    loading={loading}
                                >
                                    Reset
                                </LoadingButton>
                            </Box>
                            <Grid container>
                                <Grid>
                                    <Link href="/signin" variant="body2">
                                        Already have an account? Sign in
                                    </Link>
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                </Container>
            </main>
        </div>
    );
};

export default ForgotPasswordContainer;
